module.exports = __webpack_public_path__ + "static/media/yellowwarning.d13e154e.png";